import { useApp } from 'contexts/app';
import { useMemo } from 'react';
import { buildSessionContext, pruneEmptyContext } from 'utils/chat/instructorHugoContext';
import { getRouteChatKey } from './useInstructorHugoChatHelpers';

const useInstructorHugoContext = ({ auth, pathname, sessionContext }) => {
    const { instructorHugoLiveContext, instructorHugoVisibleRows, instructorHugoPageView } = useApp();

    const derivedSessionContext = useMemo(() => buildSessionContext({ auth, pathname }), [auth, pathname]);
    const currentRouteChatKey = useMemo(
        () => getRouteChatKey({ auth, sessionContext: derivedSessionContext }),
        [auth, derivedSessionContext]
    );

    const threadContext = sessionContext;
    const currentRouteContext = derivedSessionContext;
    const { pageContext, routeContext } = currentRouteContext;
    const outgoingPageContext = useMemo(
        () =>
            pruneEmptyContext({
                ...pageContext,
                active_tab:
                    pageContext.page_type === instructorHugoPageView?.page_type
                        ? instructorHugoPageView.view
                        : pageContext.active_tab,
                selected_item_id: routeContext.detailId,
                visible_rows: instructorHugoVisibleRows,
            }),
        [instructorHugoPageView, instructorHugoVisibleRows, pageContext, routeContext.detailId]
    );

    return {
        currentRouteChatKey,
        derivedSessionContext,
        outgoingContext: instructorHugoLiveContext,
        outgoingPageContext,
        scope: threadContext.scope,
    };
};

export default useInstructorHugoContext;
